import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';

@Injectable({ providedIn: 'root' })
export class AcDefaultFilterApiClient {
  public constructor(private readonly baseHttpService: BaseHttpService) {}

  public getDefaultFilter(tenantId: string): Observable<any> {
    return this.baseHttpService.get(`organization-unit-manager/v2/tenants/${tenantId}/default-graph-user-filter`);
  }
}
